<script setup>
/* eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text */
const props = defineProps({ metrics: { type: Object, default: () => ({}) } });
const count = v =>
  v == null ? 'Нет данных' : Number(v).toLocaleString('ru-RU');
const unit = () => {
  if (props.metrics.metric_kind === 'followers') return 'подписчиков';
  if (props.metrics.metric_kind === 'other') return 'выполнений';
  return 'ед. (тип не определён)';
};
const price = v =>
  v == null
    ? 'Нет данных'
    : `${Number(v).toLocaleString('ru-RU', { maximumSignificantDigits: 12 })} ₽`;
</script>

<template>
  <div class="flex flex-col gap-1 text-sm min-w-0">
    <p class="m-0 text-n-slate-12">
      Заказано {{ unit() }}: {{ count(metrics.ordered_quantity) }}
    </p>
    <p class="m-0 text-n-slate-12">
      Выполнено: {{ count(metrics.delivered) }} · Осталось:
      {{ count(metrics.remaining) }}
    </p>
    <p v-if="metrics.metric_kind === 'followers'" class="m-0 text-n-slate-11">
      Цена выполненного подписчика: {{ price(metrics.subscriber_unit_cost) }}
    </p>
    <p v-else class="m-0 text-n-slate-11">
      Цена подписчика не рассчитывается:
      {{
        metrics.metric_kind === 'other'
          ? 'другая услуга'
          : 'тип услуги не подтверждён'
      }}.
    </p>
    <p v-if="metrics.progress_error_code" class="m-0 text-n-amber-11">
      Данные выполнения неполные или требуют проверки.
    </p>
    <p v-if="metrics.progress_checked_at" class="m-0 text-xs text-n-slate-11">
      По данным SexySMM на
      {{
        new Date(metrics.progress_checked_at).toLocaleString('ru-RU', {
          timeZone: 'Europe/Moscow',
        })
      }}
      МСК{{ metrics.progress_stale ? ' · устарело' : '' }}.
    </p>
  </div>
</template>
